import { API, API_POST } from "../../config";

export const DeleteUser = (id,status) => {
  const f = new FormData();
  f.append("uid", id);
  f.append("status", status);

  return API_POST(API.UserDelete, f);
};
